<template>
  <div class="InformationForm">
    <div class="alert">
      <div class="el-icon-ali-jinggao"></div>
      <div>
        <span class="black"> 你所入录信息在对外展示时都</span
        >会进行脱敏处理，不会造成个人信息泄露
      </div>
    </div>
    <el-form :model="form" ref="form" @submit.native.prevent label-position="top">
      <div class="box">
        <hdq-section title="发布来源" moreText="" />
        <div class="content">
          <el-form-item :rules="{ required: true, message: '请输入账号名称' }">
            <el-input
              disabled
              :value="user.name"
              placeholder="请输入账号名称"
              style="width: 416px"
            ></el-input>
            <template slot="label">
              <span style="color: #262626">账号名称</span>
            </template>
          </el-form-item>
        </div>
      </div>
      <div class="box">
        <hdq-section title="信息内容" moreText="">
          <template slot="left">
            <div class="leftSlot">
              <div class="img" @click="changeType('image')">
                <span class="el-icon-picture-outline"></span>
                图片
              </div>
              <div class="video" @click="changeType('video')">
                <span class="el-icon-video-camera"></span>
                视频
              </div>
            </div>
          </template>
        </hdq-section>
        <div class="content">
          <el-form-item
            prop="content"
            :rules="{ required: true, message: '请输入具体信息' }"
          >
            <el-input
              type="textarea"
              v-model.trim="form.content"
              placeholder="请输入具体信息..."
              style="width: 100%"
              :maxlength="500"
              :minlength="20"
              :show-word-limit="true"
              :autosize="{ minRows: 6, maxRows: 8 }"
            ></el-input>
            <template slot="label">
              <span style="color: #262626"
                >具体信息<span style="color: #666 !important">（最低20字）</span></span
              >
            </template>
          </el-form-item>
          <template v-if="type === 'video'">
            <el-form-item
              prop="url"
              :rules="{ required: true, message: '请上传视频文件' }"
            >
              <template slot="label">
                <span style="color: #262626">视频文件</span>
              </template>
              <videoItem ref="videoItemRef" v-model="form.url" />
            </el-form-item>

            <el-form-item
              prop="coverUrl"
              :rules="{ required: true, message: '请选择视频封面' }"
            >
              <template slot="label">
                <span style="color: #262626"
                  >设置封面<span style="color: #666 !important"
                    >（请选择一种封面）</span
                  ></span
                >
              </template>
              <videoCover v-model="form.coverUrl" />
            </el-form-item>
          </template>
          <template v-if="type === 'image'">
            <el-form-item
              prop="url"
              :rules="{ required: true, message: '请选择视频封面' }"
            >
              <template slot="label">
                <span style="color: #262626">图片文件</span>
              </template>
              <imageItem v-model="form.url" />
            </el-form-item>
          </template>
        </div>
      </div>
      <div class="box footer">
        <el-button class="button" @click="close">取消</el-button>
        <el-button
          class="button"
          type="primary"
          @click="onSubmin"
          :disabled="!form.content"
          >提交</el-button
        >
      </div>
    </el-form>
  </div>
</template>

<script>
import userInfo from "@/mixins/userinfo.js";
import videoItem from "@/components/form/videoItem.vue";
import imageItem from "@/components/form/imageItem.vue";
import videoCover from "@/components/form/videoCover.vue";
export default {
  mixins: [userInfo],
  components: {
    videoItem,
    videoCover,
    imageItem,
  },
  data() {
    return {
      type: "",
      form: {
        content: "",
        coverUrl: "",
        url: "",
      },
    };
  },
  created() {},
  computed: {},
  methods: {
    changeType(type) {
      this.form.url = "";
      if (this.type !== type) {
        this.type = type;
      } else {
        this.type = "";
      }
    },
    async videoSuccess(val) {
      console.log("videoSuccess", val);
      await this.$nextTick();
      this.$refs.videoItemRef.setVideoData(val);
    },
    videoOnProgress() {},
    close() {
      this.$router.go(-1);
    },
    onSubmin() {
      this.postPlazaMessage();
    },
    async postPlazaMessage() {
      const { content, url, coverUrl } = this.form;
      if (content.length < 20) {
        this.$message({
          type: "error",
          message: "信息内容最少20字",
        });
        return;
      }
      let parm = {};
      if (this.type === "image") {
        parm.content = content;
        parm.url = url;
        parm.type = 1;
      } else if (this.type === "video") {
        parm.content = content;
        parm.url = url;
        parm.coverUrl = coverUrl;
        parm.type = 2;
      } else {
        parm.content = content;
        parm.type = 1;
      }
      const { status, info, data } = await this.$api.postPlazaMessage(parm);
      if (status === 200) {
        this.$message({
          type: "success",
          message: data || info,
        });

        setTimeout(() => {
          this.$router.push({
            path: "/Information/InformationMy",
            query: {
              status: 0,
            },
          });
        }, 1000);
        this.form = {
          content: "",
          coverUrl: "",
          url: "",
        };
      } else {
        this.$message({
          type: "error",
          message: data || info,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.InformationForm {
  display: flex;
  flex-direction: column;
}
.alert {
  border-radius: 2px;
  background: #eff6ff;
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 16px;
  font-family: "Noto Sans SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  /* 185.714% */
  color: #0062ff;
  gap: 8px;
  .black {
    color: #262626;
  }
}
.box {
  background: #fff;
  border-radius: 4px;
  margin-top: 16px;
  @include formStyle;
  ::v-deep .el-form-item {
    margin-bottom: 16px;
  }
  .content {
    padding: 0 16px;
    padding-bottom: 20px;
  }
  .leftSlot {
    display: flex;
    align-items: center;
    gap: 20px;
    color: #666666;
    cursor: pointer;
    span {
      color: #999999;
    }
    .img,
    .video {
      font-size: 14px;
      &:hover {
        color: #0062ff;
        span {
          color: #0062ff;
        }
      }
    }
    .acitve {
      color: #0062ff;
      span {
        color: #0062ff;
      }
    }
  }
}
.footer {
  height: 66px;
  padding: 0 16px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
